// Container Trader: display-time wording fixes for Container Trader managed (Buy It Now) listings.
// The stored listing description is not changed; only how it is shown on the listing page.

export const CT_MANAGED_LISTING_TYPE = 'container-trader-managed';

const OLD_CONTACT_LINE =
  'Contact us through Container Trader for availability, purchasing information, or a delivery quote.';

export const CT_MANAGED_CONTACT_LINE =
  'Click Buy now to purchase with a card, or send us a message for a delivery quote or for an invoice you can pay by wire transfer or ACH to avoid the credit card fee.';

export const ctListingDescription = (description, publicData) => {
  if (typeof description !== 'string') return description;
  if (publicData?.listingType !== CT_MANAGED_LISTING_TYPE) return description;
  return description.split(OLD_CONTACT_LINE).join(CT_MANAGED_CONTACT_LINE);
};
